import React, { Component } from "react";
import {  Spin } from "antd";
import UploadPdf from '../UploadPdf'
//import PdfPreview from '../PdfPreview'

export default class Ricette extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastUpdated: "",
      loading: false,
    };

    this.setLoading = this.setLoading.bind(this)
  }

  setLoading(loading) {
    this.setState({ loading })
  }


  renderAll() {
    if (this.state.loading) {
      return <Spin />;
    } else {

      return (<div>
        <UploadPdf id={this.props.id} prefix="Ricette" type="pdf" setLoading={this.setLoading} />
        <UploadPdf id={this.props.id} prefix="Ricette" type="image" setLoading={this.setLoading} />
      </div>)

    }
  }


  renderPdfViewer() {
    if (this.state.loading === false) {
      return (<div>
        {/* <PdfPreview url={`${process.env.REACT_APP_SERVER_URL}/api/files/GetRicette?id=${this.props.id}`} /> */}
        <a style={{ color: 'blue', textAlign: 'right' }} href={`${process.env.REACT_APP_SERVER_URL}/api/files/GetRicette?id=${this.props.id}`}> Scarica il pdf </a> </div>)
    }
  }

  render() {
    return (
      <div className="elevation" >
        <h2 style={{ textAlign: 'center' }}> Ricetta {this.props.id} </h2>


        <div className="upload_and_thumb">
          {this.renderPdfViewer()}
          {this.state.loading === false && <img src={`${process.env.REACT_APP_SERVER_URL}/api/files/GetThumbnail?type=ricette&id=${this.props.id}`} height="150px" alt="imagine di ricetta" />}
        </div>


        {this.renderAll()}
      </div>
    );
  }
}
